module.exports = __webpack_public_path__ + "static/landingDesktop-7c2216b45d18406b8dd0b15f6875ef22.png";